// extracted by mini-css-extract-plugin
export default {"container":"trackingFooter_container__2m2LD","containerHomePage":"trackingFooter_containerHomePage__sC8OM"};